import clsx from 'clsx';
import { Trans } from 'react-i18next';

import { Content } from '@/lib';
import { DataLayer } from '@/components';
import styles from './Banner.module.scss';
import { Row } from '../../Row';
import BannerAnimation from './BannerAnimation';

interface BannerProps extends Content.Banner {
  onButtonClick?: () => void;
}

export function Banner({ title, text, fluid, button, onButtonClick }: Content.WithFluid<Content.Banner & BannerProps>) {
  return (
    <div className={styles.wrapper}>
      <Row className={clsx(styles.row, fluid && styles.fluid)}>
        <div className={styles.contentWrapper}>
          <div className={styles.content}>
            <h2 className={clsx(styles.title, 'h2')}>
              <Trans defaults={title} t={((key: string) => title || key) as never}>
                Custom server-side tagging infrastructure <BannerAnimation>on your servers ?</BannerAnimation>
              </Trans>
            </h2>
            <p className={clsx(styles.description, 'text')}>
              <Trans defaults={text} t={((key: string) => text || key) as never}>
                We can manually install server-side tagging infrastructure on your servers and adapt it to your need.{' '}
                <BannerAnimation>Custom setup on your servers.</BannerAnimation>
                Yeah, we mean it.
              </Trans>
            </p>
          </div>
          {!!button && (
            <a
              href={button.url}
              className={clsx(styles.action, 'btn btn-md btn-green shadow-orange-md')}
              onClick={() => {
                if (button.url.includes('/quote')) {
                  DataLayer.pushTryForFreeClickEvent('get_quote_banner');
                }
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                !!onButtonClick && onButtonClick();
              }}
              target="_blank"
              rel="noreferrer"
            >
              {button.text}
            </a>
          )}
        </div>
        {!fluid && <div className={styles.overlap} />}
      </Row>
    </div>
  );
}
